module.exports = __webpack_public_path__ + "static/video-thumbnail-824e14922745b8b74f171625fb76a31a.png";